module.exports = __webpack_public_path__ + "static/img/rank_204.31168c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_204.png
// module id = P2O0
// module chunks = 1